<div class="body">

    <iframe class="frame" [src]="href"></iframe>

</div>